import type { AiVisibilityRunInfo } from '@cmoh/shared'
import { useApiQuery } from '@/hooks/use-api'
import { useCurrentOrganization } from '@/hooks/use-current-organization'
import { AI_VISIBILITY_API_PATHS, AI_VISIBILITY_QUERY_KEYS } from '../api/ai-visibility.api'

export function useAiVisibilityRuns() {
  const { organization } = useCurrentOrganization()
  const organizationId = organization?.id ?? null
  const enabled = organizationId !== null && organization?.aiVisibility != null

  return useApiQuery<AiVisibilityRunInfo[]>(
    AI_VISIBILITY_QUERY_KEYS.runs(organizationId),
    AI_VISIBILITY_API_PATHS.RUNS,
    undefined,
    {
      enabled,
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: Number.POSITIVE_INFINITY,
      retry: 1,
    },
  )
}
